import { Component, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { TrackingService } from '@core/services';

@Component({
    selector: 'gh-newsletter-form',
    templateUrl: 'newsletter-form.component.html',
    standalone: false
})

export class NewsletterFormComponent {
  iframeSrc: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private trackingService: TrackingService
  ) {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.gohenry.com/uk/newsletter'
    );
  }

  @HostListener('window:blur', ['$event'])
  onWindowBlur(event: any): void {
    console.log('iframe clicked');
    this.formClick();
  }

  formClick() {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'form_click',
      events: {
        feature: 'blog',
        environment: environment.env,
        location: location.pathname
      }
    });
  }
}
